/**
 * About page describing the purpose and resources for the tool.
 * @param {Object} props Component props
 */
const Layout = (props) => {
  return (
    <main className="site-main container about">
      <div className="home-options">
        <div className="row">
          <div className="col-12 ">
            <h1>About</h1>
            <p>
              Color Palette Tool was created by{" "}
              <a href="https://www.linkedin.com/in/mattvrtis/">Matt Vrtis</a>{" "}
              with the help of{" "}
              <a href="https://www.linkedin.com/in/jim-resnowski-4a1476">
                Jim Resnowski
              </a>{" "}
              and{" "}
              <a href="https://www.linkedin.com/in/ryan-merritt-205784105/">
                Ryan Merritt
              </a>
              .
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <h2>Accessible Color Systems</h2>
            <p>
              The goal was to create a tool that would allow designers and
              developers to create accessible color systems. We wanted to create
              a tool that would allow users to create color palettes that would
              meet the WCAG 2.1 AA standards for contrast.
            </p>
            <h2>Consistent Colors</h2>
            <p>
              By creating consistent naming conventions for colors, we ensure
              that color palettes are easy to understand and maintain across
              projects.
            </p>
            <p>
              Developers and Designers can both speak the same language when
              working on projects together instead of relying sharing hex values
              or using color pickers. blue-60 is a consistent value and can be
              used to communicate the correct shade rather than needing a medium
              blue.
            </p>
            <h2>Easier Accessibility Checks</h2>
            <p>
              After creating a palette, users can easily check the accessibility
              of their colors using simple math.
            </p>
            <p>
              As long one color is 5 or more steps away from another color in
              the palette, the contrast is considered accessible.
            </p>
            <p>
              You could use text blue-70 value on yellow-20 background or a
              red-20 background, or any other color that is lighter. Designers
              don't need to add hex values to online checkers, developers don't
              need to worry about colors just the variable names.
            </p>
            <div className="about-examples row">
              <div className="col-4 about-example-1 p-3">
                <div>green-40 on green-90</div>
                <div>90 - 40 = 50</div>
                <div>Passes</div>
              </div>
              <div className="col-4 about-example-2 p-3">
                <div>blue-40 on orange-90</div>
                <div>90 - 40 = 50</div>
                <div>Passes</div>
              </div>
              <div className="col-4 about-example-3 p-3">
                <div>green-90 on yellow-50</div>
                <div>90 - 50 = 40</div>
                <div>Fails</div>
              </div>
            </div>
            <h2>How the eyes see contrast</h2>
            <p>
              The human eye sees contrast differently than a computer. The eye
              is more sensitive to changes in lightness than changes in hue or
              saturation. The WCAG 2.1 AA standards for contrast are based on
              the lightness of colors, which is why we use the lightness value
              to determine if colors are accessible. By using a consistent
              naming convention for colors, we can ensure that our color
              palettes pass automated accessibility checks and are easy to
              maintain across projects.
            </p>
            <p>
              This tool will generate mathmatically accessible colors, but you
              can still have combinations that pass but aren't visually
              accessible and look like garbage.
            </p>
            <div className="mt-3">
              <a href="https://github.com/w3c/wcag3/issues/192">
                Contrast Ratio Math and Related Visual Issues (problems with
                WCAG 2.1)
              </a>
            </div>

            <h3>Why HSLuv?</h3>
            <p>
              Traditional RGB/HSL/HSV color spaces are not perceptually uniform.
              For example the same "lightness" value of yellow appears much
              brighter than a blue. HSLuv is a human-friendly alternative to HSL
              that is perceptually uniform.
            </p>
            <h3>OKLCH is coming</h3>
            <p>
              OKLCH is a perceptually uniform color space that is being
              standardized by the W3C and is widely supported by modern
              browsers. It is based on the Oklab color space, which is designed
              to be more perceptually uniform than traditional color spaces.
              OKLCH has an advantage over HSLuv as it has better support for{" "}
              <a href="https://www.w3.org/TR/css-color-4/#predefined-display-p3">
                Display P3
              </a>{" "}
              which has a wider gamut support. Display P3 offers 50% wider gamut
              support than the sRGB color space which is what HSLuv is based on.
            </p>
            <ul>
              <li className="mb-2">
                <a href="https://bottosson.github.io/posts/oklab/">
                  A perceptual color space for image processing
                </a>
              </li>
              <li className="mb-2">
                <a href="https://www.w3.org/TR/css-color-4/#oklch">
                  W3.org CSS Color Module Level 4
                </a>
              </li>
              <li>
                <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/Reference/Values/color_value/oklch">
                  oklch() on MDN
                </a>
              </li>
            </ul>
            <h2>Additional Resources</h2>
            <ul>
              <li className="mb-2">
                <a href="https://www.w3.org/TR/WCAG21/#contrast-minimum">
                  WCAG 2.1 AA Contrast Standards
                </a>
              </li>
              <li className="mb-2">
                <a href="https://www.hsluv.org/">
                  HSLuv is a human-friendly alternative to HSL
                </a>
              </li>
              <li className="mb-2">
                <a href="https://stripe.com/blog/accessible-color-systems">
                  Designing accessible color systems
                </a>
              </li>
              <li>
                <a href="https://evilmartians.com/chronicles/oklch-in-css-why-quit-rgb-hsl">
                  OKLCH in CSS: why we moved from RGB and HSL
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Layout;
